import { isFavourite } from 'helpers/Project'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'

import ProjectHeader from './ProjectHeader'

// The nested string interpolation is so that we can return a quoted string
// of the user ID if available, but a standard JS null if not
const hotjarSnippet = (userID) => {
  return `
    window.hj=window.hj||function(){(hj.q=hj.q||[]).push(arguments)};
    window.hj(
      'identify',
      ${userID ? `'${userID}'` : null},
      {
        'Logged In': ${!!userID}
      }
    )
  `
}

const ProjectHeaderContainer = ({
  authentication,
  currentLocale,
  dispatch,
  favourite,
  project,
  projectComplete,
}) => (
  <>
    <Helmet>
      <script>{hotjarSnippet(authentication.user?.profile?.user)}</script>
    </Helmet>
    <ProjectHeader
      authentication={authentication}
      dispatch={dispatch}
      favourite={favourite}
      hardware={project.hardware}
      imageUrl={project.heroImage}
      included={project.included}
      locale={currentLocale}
      projectComplete={projectComplete}
      projectId={project.id}
      software={project.software}
      title={project.title}
      loading={project.loading}
    />
  </>
)

ProjectHeaderContainer.propTypes = {
  authentication: PropTypes.object,
  currentLocale: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  favourite: PropTypes.bool.isRequired,
  project: PropTypes.object.isRequired,
  projectComplete: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  const { project, currentLocale } = state.project
  const { authentication, dispatch } = state
  return {
    authentication,
    currentLocale,
    dispatch,
    favourite: isFavourite(state.favourites, state.project.project),
    project,
  }
}

export default connect(mapStateToProps)(ProjectHeaderContainer)
